import { Pipe, PipeTransform } from '@angular/core';
import { LocationResponse } from '../../../core/clients/omni-core/models';
import { formatAddress } from './location-address-pipe';

export const formatLocationName = (
  location: Partial<LocationResponse> | null | undefined,
): string => {
  if (!location) {
    return '';
  }
  if (!location.address) {
    return location.name || '';
  }
  if (!location.name || location.name.trim().length === 0) {
    return formatAddress(location.address);
  }
  return location.name.trim();
};

@Pipe({
  name: 'formatLocationName',
})
export class LocationNamePipe implements PipeTransform {
  transform(location: Partial<LocationResponse> | null | undefined): string {
    return formatLocationName(location);
  }
}
